/**
 * Canonical user-facing labels for pipeline stages.
 *
 * Stage codes (MCQ, VIDEOBOT, …) stay as protocol values. Only display
 * strings go through this helper so aptitude copy stays IQ Assessment.
 */

export const IQ_ASSESSMENT_LABEL = 'IQ Assessment';

const LEGACY_IQ_LABELS = new Set([
  'mcq',
  'mcq assessment',
  'psa',
  'psa assessment',
  'psa bank',
  'psa question bank',
]);

export const STAGE_DISPLAY_LABEL = {
  RESUME: 'Resume',
  VIDEOBOT: 'Video Bot',
  MCQ: IQ_ASSESSMENT_LABEL,
  TECH_ASSESSMENT: 'Tech Assessment',
  PANEL: 'Panel Interview',
  CODE_PANEL: 'Panel Interview',
  OFFER: 'Offer',
  CODE: 'Code Editor',
  AI_REPORT: 'AI Report',
  CLIENT_SHARE: 'Client Share',
};

function normalizeKey(value) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');
}

function isLegacyIqLabel(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;
  if (LEGACY_IQ_LABELS.has(raw.toLowerCase())) return true;
  const key = normalizeKey(raw);
  return key === 'MCQ' || key === 'PSA' || key === 'MCQ_ASSESSMENT' || key === 'PSA_ASSESSMENT';
}

function isIqStageCode(code) {
  const key = normalizeKey(code);
  return key === 'MCQ' || key === 'PSA' || key === 'MCQ_ASSESSMENT' || key === 'PSA_ASSESSMENT';
}

/** Display label for a stage code, overlaying legacy MCQ/PSA names. */
export function displayStageLabel(code, storedLabel) {
  const stored = String(storedLabel || '').trim();
  if (isIqStageCode(code) || isLegacyIqLabel(code) || isLegacyIqLabel(stored)) {
    if (stored && !isLegacyIqLabel(stored) && !isIqStageCode(stored)) {
      return stored;
    }
    return IQ_ASSESSMENT_LABEL;
  }
  if (stored) return stored;
  const mapped = STAGE_DISPLAY_LABEL[normalizeKey(code)];
  if (mapped) return mapped;
  return String(code || '').trim();
}
